export default __webpack_public_path__ + "static/media/uiux.b95b7f44.jpg";